const itemCount = {
  fontSize: '12px',
  fontWeight: 850,
  lineHeight: '16px',
  letterSpacing: 'normal'
}

const title = {
  fontSize: '20px',
  lineHeight: '25px',
  fontWeight: '850',
  textTransform: 'uppercase',
  'screen-medium': {
    fontSize: '24px',
    lineHeight: '30px'
  }
}

const loyaltyProductsGrid = {
  itemCount,
  title
}

export default loyaltyProductsGrid
